import { render, staticRenderFns } from "./WelcomeMessages.vue?vue&type=template&id=0298d50c&scoped=true"
import script from "./WelcomeMessages.vue?vue&type=script&lang=js"
export * from "./WelcomeMessages.vue?vue&type=script&lang=js"
import style0 from "./WelcomeMessages.vue?vue&type=style&index=0&id=0298d50c&prod&lang=scss&scoped=true"
import style1 from "./WelcomeMessages.vue?vue&type=style&index=1&id=0298d50c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0298d50c",
  null
  
)

export default component.exports